import SyndicatorsListContainer from 'containers/Syndicators/SyndicatorsList'
import React from 'react'

const SyndicatorListPage = () => <SyndicatorsListContainer />

export default SyndicatorListPage
